import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import CssBaseline from "@mui/material/CssBaseline";
import Header from "./Header";
import style from "../Common/style";
import MainRouter from "./MainRouter";
import Menu from "./Menu";
import { useLocation } from "react-router";
import ErrorSnackbar from "./Snackbar/ErrorSnackbar";
import { Button } from "@mui/material";
import ReactGA from "react-ga4";
import SuccessSnackbar from "./Snackbar/SuccessSnackbar";
import { clearErrors } from "../../actions/commonActions";

const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
const gaPaths = ["/dashboard", "/tms/", "/jp/", "/rms/", "/portfolio/"];

const Layout = (props) => {
    const classes = style();
    const buttonRef = useRef();
    const mainContentRef = useRef();
    const [open, setOpen] = useState(false);
    const [gaInitialised, setGaInitialised] = useState(false);
    const dispatch = useDispatch();

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const location = useLocation();

    useEffect(() => {
        if (!!gaId && gaPaths.includes(location.pathname)) {
            if (!gaInitialised) {
                ReactGA.initialize(gaId);
                setGaInitialised(true);
            }
            ReactGA.send({ hitType: "pageview", page: location.pathname });
        }
        clearErrors(dispatch);
    }, [location, gaInitialised, dispatch]);

    const findComponent = () => {
        const parts = location.pathname.split("/");
        switch (parts[1]) {
            case "jp":
                return "Job planner";
            case "lrs":
                return "LRS";
            case "msf":
                return "360 Feedback ";
            case "portfolio":
                return "Portfolio";
            case "rms":
                return "Appraisal";
            case "tms":
                return "Training";
            case "rs":
                return "Rostering";
            case "subscriptions":
                return "Subscriptions";
            case "settings":
                return "Settings";
            case "help":
                return "Help";
            default:
                return "Centric";
        }
    };

    const title = findComponent();
    document.title = title === "Centric" ? title : `${title} | Centric`;

    return (
        <div className={classes.root}>
            <span ref={buttonRef} className={classes.hiddenSkipButton}>
                <Button
                    variant="contained"
                    onClick={() => mainContentRef.current.focus()}
                    onFocus={() =>
                        (buttonRef.current.className =
                            classes.visibleSkipButton)
                    }
                    onBlur={() =>
                        (buttonRef.current.className = classes.hiddenSkipButton)
                    }
                >
                    Skip to content
                </Button>
            </span>
            <CssBaseline />
            <Header
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                open={open}
                toolBarTitle={title}
            />
            <Menu open={open} handleClose={handleDrawerClose} />
            <div
                id="MainContent"
                className={clsx(classes.content, {
                    [classes.contentShift]: open,
                })}
                ref={mainContentRef}
                tabIndex={0}
            >
                <MainRouter />
            </div>
            <ErrorSnackbar />
            <SuccessSnackbar />
        </div>
    );
};

export default Layout;
